import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import PatientAppointmentBody from "components/PatientManagement/PatientAppointment/PatientAppointmentBody";

const PatientAppointment = () => {
  useEffect(() => {
    document.title = "Appointments";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <PatientAppointmentBody />
    </main>
  );
};

export default PatientAppointment;
